import { DeleteProcessRequestSchema, DeleteProcessResponseSchema } from './delete-process.schema';
/**
 * Delete Process Endpoint Contract
 * Deletes a process by ID
 */ export const deleteProcessContract = {
    method: 'DELETE',
    path: '/api/v2/process/:id',
    description: 'Delete a process by ID',
    requestSchema: DeleteProcessRequestSchema,
    responseSchema: DeleteProcessResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'Process not found'
        }
    }
};

//# sourceMappingURL=delete-process.contract.js.map